
import FinePrint from '/src/com/yext/platform/users/js/newloginhelpers/fineprint';
import {isWhitelabeled} from '/src/com/yext/platform/users/js/newloginhelpers/logincomponents';
import {yext} from '/ui/lib/msg';

const {
  Box,
  Button,
  Card,
  Center,
  FALArrowLeft,
  Flex,
  Link,
  Text,
  VStack,
  Yext,
  Image,
} = require('@yext/mana-ui');

/**
 * Shared component for the login pages. Renders the common components shared by all login pages,
 * such as the logo, title, card, and footer.
 */
export default function NewLoginTemplate({
  title,
  subtitle,
  cardContent,
  whitelabelInfo,
  username,
  pageType,
  isMobileRedirect,
  showBackToUsername,
  isAllState,
  onBackClick,
}) {
  return (
    <Flex direction={'column'} minH={'100vh'} maxW={'100vw'}>
      <Center flex={1} padding={8}>
        <VStack w={'384px'} spacing={8} align={'stretch'}>
          <Title title={title} subtitle={subtitle} whitelabelInfo={whitelabelInfo} />
          {!isAllState && (
            <>
              {pageType === 'resetPassword' && (
                <Card size={'sm'} variant={'transparent'} maxW={'100%'} mx={'auto'}>
                  <Text fontSize={'md'} color={'text.primary'} textAlign={'center'}>
                    {username}
                  </Text>
                </Card>
              )}
              <Card size={'lg'} variant={'elevated'}>
                {cardContent}
              </Card>
              {showBackToUsername && <BackToUsernamePage onBackClick={onBackClick} />}
              {pageType === 'login' && !isWhitelabeled(whitelabelInfo) && !isMobileRedirect && <HearsaySignIn />}
            </>
          )}
        </VStack>
      </Center>
      <Box as={'footer'} textAlign={'center'} paddingY={4}>
        <FinePrint whitelabelInfo={whitelabelInfo} />
      </Box>
    </Flex>
  );
}

function HearsaySignIn() {
  return (<Flex align={'center'} justify={'center'}>
    <Text fontSize={'md'} mr={1}>
      {yext.msg('Looking for Hearsay products? ')}
    </Text>
    <Link
      as={'a'}
      href={'https://login.hearsaysocial.com'}
      palette={'primary'}
      size={'md'}
    >
      {yext.msg('Sign in Here')}
    </Link>
  </Flex>);
}

function Title({title, subtitle, whitelabelInfo}) {
  return (
    <VStack spacing={[4, 10]}>
      {hasWhitelabelLogo(whitelabelInfo) ? <WhitelabelLogo whitelabelInfo={whitelabelInfo}/> : <Yext fontSize={'7xl'}/>}
      <VStack spacing={0.5}>
        <Text fontSize={'4xl'} color={'text.neutralDominant'} align={'center'}>
          {title}
        </Text>
        <Text fontSize={'md'} color={'text.neutralSoft'} align={'center'}>
          {subtitle}
        </Text>
      </VStack>
    </VStack>
  );
}

function WhitelabelLogo({whitelabelInfo}) {
  return (
    <Image
      src={whitelabelInfo.scanLogo}
      width={'190px'}
      height={'120px'}
      objectFit={'contain'}
      backgroundRepeat={'no-repeat'}
      backgroundPosition={'center'}
    />
  );
}

const BackToUsernamePage = ({onBackClick}) => {
  const handleClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      window.location = '/users/login' + window.location.search;
    }
  };

  return (
    <Button
      onClick={handleClick}
      size={'md'}
      variant={'ghost'}
      alignSelf={'center'}
      marginBottom={'-0.5rem'}
    >
      <FALArrowLeft/>
      {yext.msg('Back')}
    </Button>
  );
};

const hasWhitelabelLogo = whitelabelInfo => {
  return isWhitelabeled(whitelabelInfo) && whitelabelInfo.scanLogo;
};
